import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=5493e1b2"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Template.vue?vue&type=custom&index=0&blockType=p"
if (typeof block0 === 'function') block0(component)

export default component.exports